import { defineApi } from '@/utils/fetch';

import { hashCreateOrderRequestBodySha256 } from './sign-create-order';

import type {
    IConfirmOrderData,
    IConfirmOrderRequestBody,
    ICreateOrderData,
    ICreateOrderRequestBody,
    IGetPaywallDetailData,
    IGetPaywallDetailRequestBody,
} from './typings';

export * from './typings';

const postPaywallDetailV1 = defineApi<IGetPaywallDetailRequestBody | undefined, IGetPaywallDetailData>({
    url: '/commerce/paywall/detail/v1',
    method: 'POST',
});

export const CommerceApi = {
    postPaywallDetailV1,

    postOrderCreateV1: defineApi<ICreateOrderRequestBody, ICreateOrderData>({
        url: '/commerce/order/create/v1',
        method: 'POST',
    }),

    postOrderConfirmV1: defineApi<IConfirmOrderRequestBody, IConfirmOrderData>({
        url: '/commerce/order/confirm/v1',
        method: 'POST',
    }),
};

export async function createCommerceOrderSigned(body: ICreateOrderRequestBody): Promise<ICreateOrderData> {
    const sign = await hashCreateOrderRequestBodySha256(body);
    const res = await CommerceApi.postOrderCreateV1({
        ...body,
        sign,
    });
    if (!res.data) {
        throw new Error('create order returned empty data');
    }
    return res.data;
}
